<template>
  <v-row>
    <v-col cols="12">
      
      <v-card class="card-quote mx-0 px-5 py-5" elevation="0">
        <transition>
          <v-row v-if="!filterBenefitsByCarriersEnabledAndPlansSelecteds || !filterBenefitsByCarriersEnabledAndPlansSelecteds.length">
            <v-col cols="12">
              <v-alert class="mx-2" outlined type="info">
                Por favor, selecione a operadora e o(s) plano(s) desejado(s).
              </v-alert>
            </v-col>
          </v-row>
        </transition>
        
        <v-row v-for="(benefit, indexBenefit) in benefits" :key="indexBenefit" justify="center" align="center" class="dashed-top my-0">
          <v-col cols="auto" style="width: 5% !important;">
            <!-- <v-img :src="$util.getImgByBenefitCode(benefit.code)" max-width="150" :max-height="$util.getImgHeightByBenefitCode(benefit.code)" contain></v-img> -->

            <div
              class="d-flex flex-row align-center"
              style="transform: rotate(-90deg);"
              v-if="$util.getImgByBenefitCode(benefit.code)">
              <v-sheet
                icon
                color="title-icon"
                class="d-flex justify-center align-center rounded-circle"
                height="38"
                min-height="38"
                width="38"
                min-width="38">
                <v-icon color="title-icon-background" size="20">{{$util.getImgByBenefitCode(benefit.code).icon}}</v-icon>
              </v-sheet>
              <span
                class="title-foreground--text font-weight-medium ml-2">
                {{$util.getImgByBenefitCode(benefit.code).description}}
              </span>
            </div>
          </v-col>

          <v-col cols="auto" style="width: 95% !important;" class="pl-0 py-0 my-0">
            <v-slide-group show-arrows>
              <v-slide-item v-for="(carrier, indexCarrier) in benefit.carriers" :key="indexCarrier">
                <v-card elevation="0" width="300" min-height="300" class="pb-5">
                  <v-card-title class="subheading d-flex justify-center">
                    <v-img v-if="carrier.image" class="mr-5" :src="`data:application/octet-stream;base64,${carrier.image}`" max-width="200" height="100" contain></v-img>
                    <v-row v-else style="height: 124px !important;">
                      <v-col cols="12" align-self="center">
                        <p class="mb-0 pb-0 font-weight-bold" style="color: var(--v-quote-base)">
                          {{carrier.comercialName ? carrier.comercialName : (carrier.name ? carrier.name : '-')}}
                        </p>
                      </v-col>
                    </v-row>
                  </v-card-title>

                  <v-row class="my-0 pb-3" justify="center" align="center">
                    <v-col class="py-0 d-flex justify-center align-content-center" cols="3" style="height: 20px !important;">
                      <v-switch 
                        class="py-0 my-0 switch-base" 
                        v-model="carrier.enabled"
                        @change="changeOthersCarriersToEnabledFalse(indexBenefit, indexCarrier)"
                        dense 
                        style="height: 20px !important;"></v-switch>
                    </v-col>
                  </v-row>
                  
                  <v-row class="my-0" justify="center" align="center" v-if="carrier.enabled">
                    <v-col cols="12" align-self="start" class="py-0">
                      <v-list dense v-for="(planClassifications, indexPlanClassification) in carrier.planClassifications" :key="indexPlanClassification">
                        <v-alert class="mx-1 my-0 font-weight-bold text-h6 foreground--text" dense color="transparent">
                          {{ planClassifications.name && planClassifications.name.trim().length ? planClassifications.name : '-' }}
                        </v-alert>
                        
                        <v-list-item 
                          style="height: 35px !important; word-break: break-word !important;"
                          :style="plan.name && plan.name.length > 25 ? {marginBottom: '10px !important', marginTop: '5px !important'} : {}"
                          class="pa-1 ma-0" 
                          v-for="(plan, indexPlan) in planClassifications.plans" :key="indexPlan">
                          <v-list-item-content class="d-flex pa-0 ma-0">
                            <v-checkbox  
                              class="px-3 py-0" 
                              :disabled="plan.disabled" 
                              v-model="plan.selected"
                              @change="verifyLimitItemsSelecteds(indexBenefit, indexCarrier, indexPlanClassification, indexPlan, plan.selected)">>
                              <template v-slot:label>
                                <span v-if="!plan.detail" style="font-size: 20px !important;">
                                  {{plan.name ? (plan.name.length > 40 ? `${plan.name.substring(0, 40)}...` : plan.name) : '-' }}
                                </span>
                                
                                <v-tooltip v-else right color="foreground">
                                  <template v-slot:activator="{ on, attrs }">
                                    <span style="font-size: 20px !important;" v-on="on" v-bind="attrs">
                                      {{plan.name ? (plan.name.length > 40 ? `${plan.name.substring(0, 40)}...` : plan.name) : '-' }}
                                    </span>
                                  </template>
                                  <span class="caption icon-color pl-1" style="font-weight: bold">
                                    {{ plan.fullDescription ? plan.fullDescription : ( plan.description ? plan.description : '')}}
                                  </span>
                                </v-tooltip>
                              </template>
                            </v-checkbox>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col>
                  </v-row>
                </v-card>
              </v-slide-item>
            </v-slide-group>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    
    <v-col cols="12" v-if="filterBenefitsByCarriersEnabledAndPlansSelecteds && filterBenefitsByCarriersEnabledAndPlansSelecteds.length">
      <v-card class="card-quote mx-0 px-5 py-3" elevation="0">
        <v-row align="center" class="my-0">
          <v-col cols="auto" style="width: 5% !important;">
            <v-img src="img/produtos/quote_calc_result.svg" max-width="150" max-height="280" contain></v-img>
          </v-col>
          
          <v-col cols="auto" style="width: 95% !important;">
            <v-row>
              <v-col cols="12" v-if="selectedJuridicalPerson === 'PJ'">
                <v-row class="py-2" v-for="(benefit, indexBenefit) in filterBenefitsByCarriersEnabledAndPlansSelecteds" :key="indexBenefit" align="center">
                  <v-col cols="6">
                    <v-row class="pb-2">
                      <v-col cols="12" class="result-text d-flex justify-center py-0">
                        {{ benefit.name }}
                      </v-col>
                      <v-col cols="12" class="result-text d-flex justify-center py-0">
                        {{ getCarrierNameByBenefit(benefit) }}
                      </v-col>
                      <v-col cols="12" class="text-center d-flex justify-center pt-1 pb-0" style="color: var(--v-foreground-base)">
                        {{ getPlanNameByBenefit(benefit) }}
                      </v-col>
                      <v-col cols="12" class="text-center d-flex justify-center pt-1 pb-0" style="color: var(--v-foreground-base)">
                        {{ getPlanCopayByBenefit(benefit) }}
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="6">
                    <v-row class="result-text pb-2" content="center" justify="center">
                      <v-col cols="12" class="d-flex justify-center pt-1 pb-0" bac>
                        {{ benefit.sumTotalLives ? `${benefit.sumTotalLives} vida(s)` : '-'}}
                      </v-col>
                      <v-col cols="12" class="d-flex justify-center pt-1 pb-0">
                        Fatura Total (R$): {{ benefit.sumTotal ? $util.formatBRL(benefit.sumTotal).replace('R$', '') : benefit.sumTotal }}
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                
                <v-row>
                  <v-col cols="6"></v-col>
                  <v-col cols="6" class="d-flex justify-center py-3">
                    <v-alert class="px-10 result-text foreground--text" dense color="muted" style="background-color: var(--v-muted-base);">
                      Total (R$): {{ this.sumTotalBenefits ? $util.formatBRL(this.sumTotalBenefits).replace('R$', '') : this.sumTotalBenefits }}
                    </v-alert>
                  </v-col>
                </v-row>
              </v-col>
              
              <v-col cols="12" v-else-if="selectedJuridicalPerson === 'PJ_PLAN'">
                <v-row class="py-2" v-for="(benefit, indexBenefit) in filterBenefitsByCarriersEnabledAndPlansSelecteds" :key="indexBenefit" align="center" justify="center">
                  <v-col cols="12" md="1" class="d-none d-sm-flex"></v-col>
                  <v-col cols="12" md="2" v-for="(plan, indexPlan) in mapPlanClassificationToPlans(benefit)" :key="indexPlan">
                    <v-col cols="12" class="result-text d-flex justify-center py-0">
                      {{ benefit.name }}
                    </v-col>
                    <v-col cols="12" class="result-text d-flex justify-center py-0">
                      {{ getCarrierNameByBenefit(benefit) }}
                    </v-col>
                    <v-col cols="12" class="text-center d-flex justify-center pt-1 pb-0" style="color: var(--v-foreground-base)">
                      {{ plan.name }}
                    </v-col>
                    <v-col cols="12" class="text-center d-flex justify-center pt-1 pb-0" style="color: var(--v-foreground-base)">
                      {{ plan.copay ? plan.copay : '-' }}
                    </v-col>
                    <v-col cols="12" class="text-center font-weight-bold d-flex justify-center pt-1 pb-0" style="color: var(--v-foreground-base)">
                      {{ plan.totalLives ? `${plan.totalLives} vida(s)` : '-' }}
                    </v-col>
                  </v-col>
                  <v-col cols="12" md="1" class="d-none d-sm-flex"></v-col>

                  <v-col cols="12">
                    <v-row class="result-text pb-4" content="center" justify="center">
                      <v-col cols="12" class="d-flex justify-center pt-1 pb-0">
                        Fatura Total (R$): {{ benefit.sumTotal ? $util.formatBRL(benefit.sumTotal).replace('R$', '') : benefit.sumTotal }}
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" class="d-flex justify-center py-3">
                    <v-alert class="px-10 result-text" dense color="foreground" style="background-color: var(--v-muted-base);">
                      Total (R$): {{ this.sumTotalBenefits ? $util.formatBRL(this.sumTotalBenefits).replace('R$', '') : this.sumTotalBenefits }}
                    </v-alert>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import {mapMutations} from "vuex";

export default {
  name: 'plansSliderSwitch',
  data: () => ({
    benefits: [],
    sumTotalBenefits: 0.0,
  }),
  props: {
    quoteData: {
      type: Object,
      required: true,
    },
    selectedJuridicalPerson: {
      type: String,
      required: true,
    }
  },
  computed: {
    filterBenefitsByCarriersEnabledAndPlansSelecteds() {
      const benefitsFiltered = this.benefits.map(benefit => {
        if(benefit && benefit.carriers.some(carrier => carrier.enabled)) {
          const carriersFiltered = benefit.carriers.filter(carrier => carrier.enabled).map(carrier => {
            const planClassificationsMaped = carrier.planClassifications.map(planClassification => {
              if(planClassification && planClassification.plans.some(plan => plan.selected)) {
                return {
                  ...planClassification,
                  plans: planClassification.plans.filter(plan => plan.selected)
                }
              } else {
                return null;
              }

            }).filter(planClassification => planClassification)

            if(carrier && planClassificationsMaped.length) {
              return {
                ...carrier,
                planClassifications: planClassificationsMaped,
              }
            } else {
              return null;
            }
          });

          if(carriersFiltered.filter(carrier => carrier).length) {
            return {
              ...benefit,
              carriers: carriersFiltered,
            }
          } else {
            return null;
          }
        }
        return null;

      }).filter(benefit => benefit);

      //calculate total cost
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.sumTotalBenefits = 0.0;
      benefitsFiltered.forEach(benefit => {
        benefit.sumTotal = 0.0;
        benefit.sumTotalLives = 0;
        benefit.carriers.forEach(carrier => {
          carrier.planClassifications.forEach(planClassification => {
            planClassification.plans.forEach(plan => {
              if(plan.totalPrice) {
                benefit.sumTotal = benefit.sumTotal + plan.totalPrice;
                benefit.sumTotalLives = benefit.sumTotalLives + plan.totalLives;
              }
            })
          })
        })
        
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sumTotalBenefits = this.sumTotalBenefits + benefit.sumTotal
      })

      return benefitsFiltered;
    }
  },
  methods: {
    ...mapMutations(['showmsg']),
    loadBenefitsAndFilterSelecteds() {
      const itemsToDelete = [];
      if(this.quoteData && this.quoteData.benefitsObj && this.quoteData.benefitsObj.length) {
        const benefitsLoaded = JSON.parse(JSON.stringify(this.quoteData.benefitsObj));
        
        //get selecteds false to remove
        benefitsLoaded.forEach((benefit, indexBenefit) => {
          benefit.carriers.forEach((carrier, indexCarrier) => {
            carrier.planClassifications.forEach((planClassification, indexPlanClassification) => {
              planClassification.plans.forEach((plan, indexPlan) => {
                if(!plan.selected) {
                  itemsToDelete.push({
                    indexBenefit: indexBenefit,
                    indexCarrier: indexCarrier,
                    indexPlanClassification: indexPlanClassification,
                    indexPlan: indexPlan,
                  });
                }
              });
            });
          });
        });

        //remove selecteds false
        if(itemsToDelete && itemsToDelete.length) {
          itemsToDelete.reverse().forEach(item => {
            benefitsLoaded[item.indexBenefit].carriers[item.indexCarrier].planClassifications[item.indexPlanClassification].plans.splice(item.indexPlan, 1);
            if(!benefitsLoaded[item.indexBenefit].carriers[item.indexCarrier].planClassifications[item.indexPlanClassification].plans.length) {
              benefitsLoaded[item.indexBenefit].carriers[item.indexCarrier].planClassifications.splice(item.indexPlanClassification, 1);
            }
            if(!benefitsLoaded[item.indexBenefit].carriers[item.indexCarrier].planClassifications.length) {
              benefitsLoaded[item.indexBenefit].carriers.splice(item.indexCarrier, 1);
            }
            if(!benefitsLoaded[item.indexBenefit].carriers.length) {
              benefitsLoaded.splice(item.indexBenefit, 1);
            }
          });
        }

        this.benefits = benefitsLoaded;
      }
    },
    changePlanSelectedAttributeToFalse() {
      const benefitsLoaded = JSON.parse(JSON.stringify(this.benefits));
      if(benefitsLoaded) {
        benefitsLoaded.forEach((benefit) => {
          benefit.carriers.forEach((carrier) => {
            carrier.planClassifications.forEach((planClassification) => {
              planClassification.plans.forEach((plan) => {
                plan.selected = false;
              });
            });
          });
        });
        this.benefits = benefitsLoaded;
      }
    },
    createCarrierEnabledAttribute() {
      const benefitsLoaded = JSON.parse(JSON.stringify(this.benefits));
      if(benefitsLoaded) {
        benefitsLoaded.forEach((benefit) => {
          benefit.carriers.forEach((carrier) => {
            carrier.enabled = carrier.isReference;
          });
        });
        this.benefits = benefitsLoaded;
      }
    },
    changeOthersCarriersToEnabledFalse(indexBenefitSelected, indexCarierSelected) {
      const benefitsLoaded = JSON.parse(JSON.stringify(this.benefits));
      if(benefitsLoaded) {
        benefitsLoaded[indexBenefitSelected].carriers.forEach((carrier, indexCarrier) => {
          if(indexCarrier !== indexCarierSelected) {
            carrier.enabled = false;
          }
        });
        this.benefits = benefitsLoaded;
      }
      this.$emit('saveBenefitsToSend', this.benefits);
    },
    verifyLimitItemsSelecteds(indexBenefit, indexCarrier, indexPlanClassification, indexPlan, statusSelected) {
      let itemsSelecteds = [];
      itemsSelecteds = itemsSelecteds.concat(...this.benefits[indexBenefit].carriers[indexCarrier].planClassifications
        .map(planClassification => planClassification.plans.map(plan =>  ({selected: plan.selected}))))
      
      let maxSelected = 1;
      if(this.selectedJuridicalPerson === 'PJ_PLAN') {
        maxSelected = 5;
      }

      if(statusSelected && itemsSelecteds.filter(item => item.selected).length === maxSelected) {
        this.benefits[indexBenefit].carriers[indexCarrier].planClassifications.forEach(planClassification => {
          planClassification.plans.forEach(plan => {
            if(plan.selected == false) {
              plan.disabled = true;
            }
          });
        });
      } else {
        this.benefits[indexBenefit].carriers[indexCarrier].planClassifications.forEach(planClassification => {
          planClassification.plans.forEach(plan => {
            plan.disabled = false;
          });
        });
      }
      this.$emit('saveBenefitsToSend', this.benefits);
    },
    getCarrierNameByBenefit(benefit) {
      if(benefit && benefit.carriers && benefit.carriers.length) {
         return benefit.carriers[0].name;
      }
      return '-';
    },
    getPlanByBenefit(benefit) {
      if(benefit && benefit.carriers && benefit.carriers.length
        && benefit.carriers[0].planClassifications && benefit.carriers[0].planClassifications.length
        && benefit.carriers[0].planClassifications[0].plans && benefit.carriers[0].planClassifications[0].plans.length) {
        return benefit.carriers[0].planClassifications[0].plans[0];
      }
      return null;
    },
    getPlanNameByBenefit(benefit) {
      if(benefit && this.getPlanByBenefit(benefit)) {
        return benefit.carriers[0].planClassifications[0].plans[0].name;
      }
      return '-';
    },
    getPlanCopayByBenefit(benefit) {
      if(benefit && this.getPlanByBenefit(benefit)) {
        return benefit.carriers[0].planClassifications[0].plans[0].copay 
          ? benefit.carriers[0].planClassifications[0].plans[0].copay : '-';
      }
      return '-';
    },
    mapPlanClassificationToPlans(benefit) {
      let plans = [];
      plans = plans.concat(...benefit.carriers[0].planClassifications.map(planClassification => {
        return planClassification.plans.map(plan => {
          return {
            ...plan,
            classificationName: planClassification.name
          }
        });
      }));
      return plans;
    }
  },
  created() {
    this.loadBenefitsAndFilterSelecteds();
    this.changePlanSelectedAttributeToFalse();
    this.createCarrierEnabledAttribute();
  },
};
</script>

<style scoped>
.dashed-top {
  border-top-color: var(--v-border-base);
  border-top-style: dashed;
  border-width: 1px;
}

.result-text {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
